import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Icon } from "rhombus-react";

import { clearRefinements } from "reducers/Refinements";
import { generateAssets, discardAsset } from "reducers/VersionGeneration";
import { getImageWithDimensions } from "./utils";
import GeneratingPlaceholder from "./GeneratingPlaceholder";
import ImageItem from "./ImageItem";

export default function ImageVariableList(props){
	const {
		libraryId,
		variableName,
		variableOptions,
	} = props;

	const [isGenerating, setIsGenerating] = useState(false);
	const dispatch = useDispatch();
	const generatedAssets = useSelector(state => state.versionGeneration?.generatedAssets);

	function regenerate(){
		setIsGenerating(true);
		const data = {
			...generatedAssets,
			images: [
				getImageWithDimensions({ name: variableName })
			],
			texts: [],
		};
		dispatch(clearRefinements());
		dispatch(generateAssets(libraryId, data, { patch: true }))
			.finally(() => {
				setIsGenerating(false);
			});
	}

	function discard(variableName, value){
		dispatch(discardAsset("images", variableName, value));
	}

	let optionList;
	if(variableOptions.length){
		optionList = variableOptions.map((option, index) => {
			return (
				<ImageItem
					index={index}
					{...option}
					variableName={variableName}
					key={option.src}
					onRemove={discard}
				/>
			);
		});
	} else {
		optionList = (
			<div className="no-assets">
				<Icon name="far fa-mug-hot" />
				No assets available
			</div>
		);
	}

	const content = isGenerating ? <GeneratingPlaceholder /> : optionList;

	return (
		<>
			<div className="variable-name">
				{variableName}
				<Icon
					name="refresh"
					className={`cypress-gen-ai-${variableName}-refresh`}
					onClick={regenerate}
					data-tip="Regenerate"
				/>
			</div>
			<div className="variable-options media-variable-options">
				{content}
			</div>
		</>
	);
}

ImageVariableList.displayName = "ImageVariableList";
